import angular from 'angular';
import uiRouter from 'angular-ui-router';
import planComponent from './plan.component';
import planFactory from './plan.factory';

const planModule = angular
  .module('plan', [uiRouter])
  .component('plan', planComponent)
  .factory('Plan', planFactory)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('plan', {
      url: '/plan',
      component: 'plan',
    });
  }).name;

export default planModule;



// WEBPACK FOOTER //
// ./client/app/components/plan/plan.js